'use client';

// 阶段 3：ChatInput 薄壳 barrel。
// - 历史调用方仍按 `import { ChatInput } from './ChatInput'` 引用；
//   现在 `ChatInput` 即 `BaseClawInputView`，同一个实现，仅做命名别名。
// - 新增的 `WelcomeChatInput` / `ConversationChatInput` 是场景入口的 forwardRef 薄壳，
//   后续阶段会把欢迎态 / 正常对话态特有的 props 配置和回调收敛到对应组件里。
// - 不要在本文件再写视图逻辑：保持目录唯一基础输入视图为 `BaseClawInputView`。

export {
  BaseClawInputView,
  BaseClawInputView as ChatInput,
  type ChatInputProps,
  type ChatInputRef,
} from './BaseClawInputView';
export { ChatInputDisclaimer } from './ChatInputDisclaimer';
export {
  ConversationChatInput,
  type ConversationChatInputProps,
  type ConversationChatInputRef,
} from './ConversationChatInput';
export type { PendingUploadAttachment } from './utils';
export {
  WelcomeChatInput,
  type WelcomeChatInputProps,
  type WelcomeChatInputRef,
} from './WelcomeChatInput';
